module.exports = __webpack_public_path__ + "static/media/check-success@3x.f9dbc272.png";